import { AggregatedMatchesSummary } from "../hooks/cityEscapeSummaries.hooks";

/**
  * Calculate the completion rate as a percentage
 */
export const calculateCompletionRate = (summary: AggregatedMatchesSummary): number => {
  if (summary.totalMatches === 0) return 0;
  return (summary.completedMatches / summary.totalMatches) * 100;
};

/**
 * Calculate the average hints per enigma
 */
export const calculateAvgHintsPerEnigma = (
  summary: AggregatedMatchesSummary
): number => {
  if (summary.totalEnigmas === 0) return 0;
  return summary.totalHints / summary.totalEnigmas;
};

/**
 * Calculate the average errors per enigma
 */
export const calculateAvgErrorsPerEnigma = (
  summary: AggregatedMatchesSummary
): number => {
  if (summary.totalEnigmas === 0) return 0;
  return summary.totalErrors / summary.totalEnigmas;
};

/**
 * Calculate the average time per match (in seconds)
 */
export const calculateAvgTimePerMatch = (
  summary: AggregatedMatchesSummary
): number => {
  if (summary.completedMatches === 0) return 0;
  return summary.totalTime / summary.completedMatches / 1000; // Convert from ms to seconds
};

/**
 * Calculate the solution request rate as a percentage
 */
export const calculateSolutionRequestRate = (
  summary: AggregatedMatchesSummary
): number => {
  if (summary.totalEnigmas === 0) return 0;
  return (summary.totalRequestedSolutions / summary.totalEnigmas) * 100;
};

/**
 * Format time in a readable format (hours:minutes)
 */
export const formatTime = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);

  if (hours > 0) {
    return `${hours}h ${mins}m`;
  }
  return `${mins}m`;
};

/**
 * Format a percentage with 1 decimal place
 */
export const formatPercentage = (
  value?: number | null,
  opts?: { defaultValue?: string }
): string => {
  if (value == null) {
    return opts?.defaultValue ?? "0%";
  }

  return `${value.toFixed(1)}%`;
};

/**
 * Format a number with 1 decimal place
 */
export const formatNumber = (
  value?: number,
  opts?: { defaultValue?: string; precision?: number }
): string => {
  return value?.toFixed(opts?.precision ?? 1) ?? opts?.defaultValue ?? "0";
};
